export const validatePhone = phone => {
  let xphone = phone.toString().replace(/[ ()-]/g, "");
  let expregular = /^([0-9]{2})(?:[2-7]|9[0-9])([0-9]{3})([0-9]{4})$/g;
  return expregular.test(xphone);
};
